<template>
  <aside
    class="specialcars-query"
  >
    <h1 class="title mt-8 mb-2">車両タイプを選択して下さい。</h1>
    <v-item-group
      v-model="query.cartype"
      class="query-cartype"
      :class="{'is-mobile': breakpoint === BREAKPOINT_XS}"
      mandatory
    >
      <v-item
        v-for="item in m_cartypes"
        :key="item.code"
        :value="item.code"
        v-slot="{active, toggle}"
      >
        <v-img
          :src="item.image"
          :aspect-ratio="4/3"
          @click="toggle"
        >
          <div
            class="item-content"
            :class="{'is-selected': active}"
          >
            <v-icon/>
            <span>{{item.name}}</span>
          </div>
        </v-img>
      </v-item>
    </v-item-group>

    <h1 class="title mt-8 mb-2">乗車定員を選択して下さい。</h1>
    <v-item-group
      v-model="query.seat"
      class="query-seat"
      :class="{'is-mobile': breakpoint === BREAKPOINT_XS}"
      mandatory
    >
      <v-item
        v-for="item in m_seats"
        :key="item.code"
        :value="item.code"
        v-slot="{active, toggle}"
      >
        <div
          class="item-content"
          :class="{'is-selected': active}"
          @click="toggle"
        >
          <v-icon/>
          <span>{{item.name}}</span>
        </div>
      </v-item>
    </v-item-group>
  </aside>
</template>

<style lang="scss">
@import '@/libs/vuetify/styles/variables.scss';
@import './query-cartype.scss';
@import './query-seats.scss';
</style>

<script>
import PartBase from '@/mixins/PartBase'

import * as C from '@/app/special/consts'

export default {
  name: 'CarQuery',
  mixins: [
    PartBase
  ],
  props: {
    query: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      m_cartypes: C.cartypes,
      m_seats: C.seats
    }
  }
}
</script>
